/**
 * @generated SignedSource<<7c89ec7c400326d1b261659da3a5d45c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SayItBackInput = {
  pcmBase64: string;
  practiceItemId: string;
};
export type SayItBackMutation$variables = {
  input: SayItBackInput;
};
export type SayItBackMutation$data = {
  readonly sayItBack: {
    readonly transcript: string;
  };
};
export type SayItBackMutation = {
  response: SayItBackMutation$data;
  variables: SayItBackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SayItBackPayload",
    "kind": "LinkedField",
    "name": "sayItBack",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transcript",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SayItBackMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "SayItBackMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "dc693296789649aee82d0ceac02fb663",
    "id": null,
    "metadata": {},
    "name": "SayItBackMutation",
    "operationKind": "mutation",
    "text": "mutation SayItBackMutation(\n  $input: SayItBackInput!\n) {\n  sayItBack(input: $input) {\n    transcript\n  }\n}\n"
  }
};
})();

(node as any).hash = "35595c960aabf90e8989d45473398ce2";

export default node;
